<template>
  <div class="management-bd">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item v-if="contractTypeData && contractTypeData.length">
          <el-radio-group
            v-model="contractTypeCurren"
            @change="onContractType"
          >
            <el-radio-button
              :label="item.value"
              v-for="(item, index) in contractTypeData"
              :key="index"
            >{{ item.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addAgreementOrder()"
            v-if="userInfo.bizType && funcView.agreement_order_add"
          >
            {{ funcView.agreement_order_add }}
          </el-button>
        </el-form-item>
        <el-form-item
          v-if="funcView.agreement_order_export"
          style="float: right; margin-right: 0 "
        >
          <el-button
            class="table-set"
            style="vertical-align: top;"
            @click="exportTable"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item
          style="float: right"
          :class="{'mr-0': !funcView.agreement_order_export}"
        >
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <el-input
            :placeholder="$t('crm_manage.htbhddbh')"
            v-model="formSearch.search"
            clearable
            @keyup.enter.native="onPageChange({ page: 1 })"
            style="width: 280px"
          >
            <template slot="append">
              <div @click="onPageChange({ page: 1 })">
                <i class="icon icon-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <!-- 租赁方 -->
        <el-form-item :label="$t('crm_manage.yi_fang')">
          <!--
            orgType
            总部:HQ
            售后公司:SC
            代理公司:JV
            服务公司:JV_SC
            大客户:CO
            租赁方:CS
          type
            1-租赁合同+框架协议 2-协议订单 3-试用订单  -->
          <!-- <custom-select
            v-model="formSearch.customerId"
            :placeholder="i18n.com_please_select"
            :props="{ label: 'partnerName', value: 'partnerOrgId' }"
            type="tree"
            url="crmContractPartnerSelectList"
            :show-all-levels="false"
            :params="{ orgType: 'CS', type: '2' }"
          ></custom-select> -->
          <el-input
            v-model="formSearch.customerName"
            :placeholder="$t('Common.com_please_input')"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <!-- 售后公司 -->
        <el-form-item :label="$t('crm_manage.shou_hou_gong_si')">
          <!-- <custom-select
            v-model="formSearch.afterServiceId"
            :placeholder="i18n.com_please_select"
            :props="{ label: 'partnerName', value: 'partnerOrgId' }"
            type="tree"
            url="crmContractPartnerSelectList"
            :show-all-levels="false"
            :params="{ orgType: 'SC', type: '2' }"
          ></custom-select> -->
          <el-input
            v-model="formSearch.afterServiceName"
            :placeholder="$t('Common.com_please_input')"
          ></el-input>
        </el-form-item>
        <!-- 甲方授权代表 -->
        <el-form-item :label="$t('crm_manage.jfsqdb')">
          <!-- <custom-select
            v-model="formSearch.partAId"
            :placeholder="i18n.com_please_select"
            :props="{ label: 'partnerName', value: 'partnerOrgId' }"
            type="tree"
            url="crmContractPartnerSelectList"
            :show-all-levels="false"
            :params="{ orgType: 'JV', type: '2' }"
          ></custom-select> -->
          <el-input
            v-model="formSearch.partAName"
            :placeholder="$t('Common.com_please_input')"
          ></el-input>
        </el-form-item>
        <!-- 提交日期 -->
        <el-form-item :label="$t('crm_manage.ti_jiao_ri_qi')">
          <custom-date-picker
            v-model="formSearch.submitTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <!-- 签订日期 -->
        <el-form-item :label="$t('crm_manage.qian_ding_ri_qi')">
          <custom-date-picker
            v-model="formSearch.signingTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <!-- 生效时间 -->
        <el-form-item :label="$t('crm_manage.sheng_xiao_shi_jian')">
          <custom-date-picker
            v-model="formSearch.effectiveDate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_manage.ji_shen_hao')">
          <el-input
            v-model="formSearch.bodyNum"
            :placeholder="$t('Common.com_please_input')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_manage.ye_wu_fu_ze_ren')">
          <el-input
            v-model="formSearch.salesman"
            :placeholder="$t('Common.com_please_input')"
          ></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="tb1"
        height="100%"
        v-loading="isLoading"
        :data="contractList"
        tableCode="contract_order"
        type="radio"
        :index="true"
        :slots="['contractNo', 'orderCode', 'customContractNo', 'productDetail', 'action']"
        @filter="filterChange"
        @column="setColumn"
        @sort="sortChange"
      >
        <template v-slot:locationNameAndSiteName="scope">
          {{getLocationNameAndSiteName(scope.row) || '-'}}
        </template>
        <template v-slot:contractNo="scope">
          <div
            v-if="funcView.agreement_order_watch"
            class="cell-link"
            @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path })"
          >
            {{ scope.row.contractNo }}
          </div>
          <span v-else>{{ scope.row.contractNo }}</span>
        </template>
        <template v-slot:orderCode="scope">
          <div
            v-if="funcView.agreement_order_watch"
            class="cell-link"
            @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path })"
          >
            {{ scope.row.orderCode }}
          </div>
          <span v-else>{{ scope.row.orderCode }}</span>
        </template>
        <template v-slot:customContractNo="scope">
          <div
            v-if="funcView.agreement_order_watch"
            class="cell-link"
            @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path })"
          >
            {{ scope.row.customContractNo }}
          </div>
          <span v-else>{{ scope.row.customContractNo }}</span>
        </template>
        <template v-slot:productDetail="scope">
          <el-popover
            placement="bottom"
            width="420"
            trigger="hover"
            v-if="scope.row.goodsCountList"
          >
            <el-table :data="scope.row.goodsCountList">
              <el-table-column
                width="100"
                property="productCode"
                :label="$t('crm_manage.xing_hao')"
              ></el-table-column>
              <el-table-column
                width="70"
                property="deviceBizType"
                :label="$t('crm_manage.she_bei_lei_xing')"
              ></el-table-column>
              <el-table-column
                width="70"
                property="bookingNum"
                :label="$t('crm_manage.shu_liang')"
              ></el-table-column>
              <el-table-column
                width="70"
                property="rentalTerm"
                :label="$t('crm_manage.zu_lin_yue_shu')"
              ></el-table-column>
              <el-table-column
                width="70"
                property="unitPrice"
                :label="$t('crm_manage.zu_jin_yue')"
              ></el-table-column>
            </el-table>
            <!-- <contract-list-table
                :data="scope.row.goodsCountList"
              ></contract-list-table> -->
            <!-- <el-button slot="reference" type="text">{{ $t('p_agreementOrder_cksbxq') }}</el-button> -->
            <el-button
              slot="reference"
              type="text"
            >{{ $t('crm_manage.cksbxq') }}</el-button>
          </el-popover>
          <el-button
            v-else
            type="text"
          >{{ $t('crm_manage.cksbxq') }}</el-button>
        </template>
        <!-- overview -->
        <template v-slot:action="scope">
          <template v-if="!scope.row.lastOrderId &&scope.row.contractHandle">
            <!--
                新增协议订单 agreement_order_add
                订单详情 agreement_order_watch
                列表 agreement_order_list
                提交 agreement_order_submit
                编辑 agreement_order_edit
                删除 agreement_order_delete
                撤销 agreement_order_cancel
                作废 agreement_order_revoke
                拷贝 agreement_order_copy
              -->
            <!-- -->
            <span></span>
            <el-button
              v-if="funcView.agreement_order_edit && scope.row.contractHandle.edit"
              type="text"
              size="mini"
              @click="editAgreementOrder(scope.row)"
            >
              {{ funcView.agreement_order_edit }}
            </el-button>
            <!-- 更多操作 -->
            <el-dropdown
              style="vertical-align: top"
              v-show="scope.row.showMoreAction"
            >
              <el-button
                type="text"
                size="mini"
              >
                <span>{{ $t('Common.com_more_action') }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  @click.native="deleteContract(scope.row)"
                  v-if="funcView.agreement_order_delete && scope.row.contractHandle.delete"
                >
                  {{ funcView.agreement_order_delete }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="submitContract(scope.row)"
                  v-if="funcView.agreement_order_submit && scope.row.contractHandle.submit"
                >
                  {{ funcView.agreement_order_submit }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="cancelContract('frame_order', scope.row.bizId)"
                  v-if="funcView.agreement_order_cancel && scope.row.contractHandle.cancel"
                >
                  {{ funcView.agreement_order_cancel }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="onEditSalesman(scope.row)"
                  v-if="funcView.agreement_order_changeSalesman && scope.row.contractHandle.changeSalesman"
                >
                  {{ funcView.agreement_order_changeSalesman }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="revokeContract('frame_order', scope.row.bizId)"
                  v-if="funcView.agreement_order_revoke && scope.row.contractHandle.revoke"
                >
                  {{ funcView.agreement_order_revoke }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="copyAgreementOrder(scope.row)"
                  v-if="funcView.agreement_order_copy && scope.row.contractHandle.copy"
                >
                  {{ funcView.agreement_order_copy }}{{ showMore(scope.row) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <!-- 续租合同 -->
          <template v-if="scope.row.lastOrderType === '31'&&!!scope.row.lastOrderId && scope.row.contractHandle">
            <!--
                新增协议订单 agreement_order_add
                订单详情 agreement_order_watch
                列表 agreement_order_list
                提交 agreement_order_submit
                编辑 agreement_order_edit
                删除 agreement_order_delete
                撤销 agreement_order_cancel
                作废 agreement_order_revoke
                拷贝 agreement_order_copy
              -->
              <!-- 根据字典配 -->
              <el-button
                v-if="funcView.agreement_order_edit && scope.row.contractHandle.edit"
                type="text"
                size="mini"
                @click="editAgreementOrder(scope.row)"
              >
                {{ funcView.agreement_order_edit }}
              </el-button>
              <!-- 更多操作 -->
              <el-dropdown
                style="vertical-align: top"
                v-show="scope.row.showMoreAction"
              >
                <el-button
                  type="text"
                  size="mini"
                >
                  <span>{{ $t('Common.com_more_action') }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="deleteContract(scope.row)"
                    v-if="funcView.agreement_order_delete && scope.row.contractHandle.delete"
                  >
                    {{ funcView.agreement_order_delete }}{{ showMore(scope.row) }}
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="submitContract(scope.row)"
                    v-if="funcView.agreement_order_submit && scope.row.contractHandle.submit"
                  >
                    {{ funcView.agreement_order_submit }}{{ showMore(scope.row) }}
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="onEditSalesman(scope.row)"
                    v-if="funcView.agreement_order_changeSalesman && scope.row.contractHandle.changeSalesman"
                  >
                    {{ funcView.agreement_order_changeSalesman }}{{ showMore(scope.row) }}
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="cancelContract('frame_order', scope.row.bizId)"
                    v-if="funcView.agreement_order_cancel && scope.row.contractHandle.cancel"
                  >
                    {{ funcView.agreement_order_cancel }}{{ showMore(scope.row) }}
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="revokeContract('frame_order', scope.row.bizId)"
                    v-if="funcView.agreement_order_revoke && scope.row.contractHandle.revoke"
                  >
                    {{ funcView.agreement_order_revoke }}{{ showMore(scope.row) }}
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="copyAgreementOrder(scope.row)"
                    v-if="funcView.agreement_order_copy && scope.row.contractHandle.copy"
                  >
                    {{ funcView.agreement_order_copy }}{{ showMore(scope.row) }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
           <!-- 试用转协议订单 -->
          <template v-if="scope.row.lastOrderType === '10'&&!!scope.row.lastOrderId && scope.row.contractHandle">
                <!-- 根据字典配 -->
                <el-button
                  v-if="funcView.agreement_order_edit && scope.row.contractHandle.edit"
                  type="text"
                  size="mini"
                  @click="editTryContinueContract(scope.row)"
                >
                  {{ funcView.agreement_order_edit }}
                </el-button>
                <!-- 更多操作 -->
                <el-dropdown
                  style="vertical-align: top"
                  v-show="scope.row.showMoreAction"
                >
                  <el-button
                    type="text"
                    size="mini"
                  >
                    <span>{{ $t('Common.com_more_action') }}</span>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      @click.native="deleteContract(scope.row)"
                      v-if="funcView.agreement_order_delete && scope.row.contractHandle.delete"
                    >
                      {{ funcView.agreement_order_delete }}{{ showMore(scope.row) }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="submitContract(scope.row)"
                      v-if="funcView.agreement_order_submit && scope.row.contractHandle.submit"
                    >
                      {{ funcView.agreement_order_submit }}{{ showMore(scope.row) }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="onEditSalesman(scope.row)"
                      v-if="funcView.agreement_order_changeSalesman && scope.row.contractHandle.changeSalesman"
                    >
                      {{ funcView.agreement_order_changeSalesman }}{{ showMore(scope.row) }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="cancelContract('frame_order', scope.row.bizId)"
                      v-if="funcView.agreement_order_cancel && scope.row.contractHandle.cancel"
                    >
                      {{ funcView.agreement_order_cancel }}{{ showMore(scope.row) }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="revokeContract('frame_order', scope.row.bizId)"
                      v-if="funcView.agreement_order_revoke && scope.row.contractHandle.revoke"
                    >
                      {{ funcView.agreement_order_revoke }}{{ showMore(scope.row) }}
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="jump('/contract/agreementOrder/leasecontinueadd', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, copy: true })"
                      v-if="funcView.agreement_order_copy && scope.row.contractHandle.copy"
                    >
                      {{ funcView.agreement_order_copy }}{{ showMore(scope.row) }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
          </template>
        </template>

      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 发送电子合同 -->
    <contract-confirm-dialog
      v-if="dialogVisible3"
      :data="dialogData3"
      :model="dialogModel3"
      @close="dialogVisible3 = false"
      @success="sendContract"
    ></contract-confirm-dialog>
    <!-- 打印租赁确认单第一步 选择设备 -->
    <contract-deviceSelect-dialog
      v-if="dialogVisible5"
      :model="dialogModel5"
      @close="dialogVisible5 = false"
    ></contract-deviceSelect-dialog>
    <!-- 修改业务负责人 -->
    <contract-salesman-dialog
      v-if="dialogVisible7"
      :model="dialogModel7"
      @close="dialogVisible7 = false"
    ></contract-salesman-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import contractRule from '@/utils/contractRule.js';
import moment from 'moment';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import contractSalesmanDialog from '@/pages/crm/contractComponents/contract_salesman_dialog.vue';

import contractDeviceSelectDialog from '@/pages/crm/components/contract_deviceSelect_dialog.vue';
import contractConfirmDialog from '@/pages/crm/contractComponents/contract_confirmSend_dialog.vue';

export default {
  name: 'agreementOrder',
  props: {
    contractTypeData: [Array], // 合同类型
    value: [String, Number],
    contractType: [String, Number],
  },
  components: {
    contractConfirmDialog,
    contractDeviceSelectDialog,
    contractSalesmanDialog
  },
  mixins: [resetFormSearchMixins],
  data() {
    return {
      // tableCode: 'contract_order',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        contractState: '',
        // contractType: ['30'],
        // bizClass: '30',
        customerName: '',
        afterServiceName: '',
        partAName: '',
        signingTime: '',
        signingStartDate: '', // 签订开始日期
        signingEndDate: '', // 签订结束日期
        submitTime: '',
        submitStartDate: '', // 创建开始时间
        submitEndDate: '', // 创建开始时间
        effectiveDate: '',
        effectiveStartDate: '', // 生效开始时间
        effectiveEndDate: '', // 生效开始时间
        locationName: '',
        bodyNum: '',
        salesman: '',
        // paymentTime: '',
        // prepaymentStartTime: '', // 首付开始日期
        // prepaymentEndTime: '', // 首付结束日期
      },
      // 更多筛选
      searchFilters: false,
      totalRows: null,
      isLoading: false,
      contractList: [],
      // 合同类型

      // 审批
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},
      // 退回
      dialogVisible2: false,
      dialogModel2: {},
      dialogData2: {},
      // 发送电子合同 确认签署
      dialogVisible3: false,
      dialogModel3: {},
      dialogData3: {},
      //  下载合同
      // dialogVisible4: false,
      // dialogModel4: {},
      //  租赁确认单
      dialogVisible5: false,
      dialogModel5: {},
      //  合同操作
      dialogVisible6: false,
      dialogModel6: {},
      //  修改业务负责人
      dialogVisible7: false,
      dialogModel7: {},

      // 用户身份
      // userInfo: {},
      // 操作
      visibleSet: '',
      dialogSetData: {},

      colsSet: [],
      link: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    contractTypeCurren: {
      get() {
        // 回调函数 当需要读取当前属性值是执行，根据相关数据计算并返回当前属性的值
        return this.contractType;
      },
      set(val) {
        // 监视当前属性值的变化，当属性值发生变化时执行，更新相关的属性数据
        this.$emit('input', val);
      },
    },
  },
  mounted() {
    this.formSearch.submitTime = [this.$momentWorld(moment().startOf('month')), this.$momentWorld(moment().endOf('day'))];
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getContract();
    // this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    // this.userInfo = this.$store.state.userInfo;
  },
  // activated() {
  //   // this.userInfo = this.$store.state.userInfo;
  //   this.getContract();
  // },
  methods: {
    addAgreementOrder() {
      this.clearTagByKeep('inventoryManagement_item');
      this.jump('/redirect/contract/agreementOrder/add', { parentPath: '/contract/agreementOrder' });
    },
    editAgreementOrder(row) {
      if (row.lastOrderId) {
        this.clearTagByKeep('agreementOrder_item_continue');
        this.jump('/contract/agreementOrder/continueedit', {
          lastOrderId: row.lastOrderId,
          contractId: row.bizId,
          contractClass: row.bizClass,
          parentPath: '/contract/agreementOrder'
        });
      } else {
        this.clearTagByKeep('inventoryManagement_item');
        this.jump('/redirect/contract/agreementOrder/edit', { parentPath: '/contract/agreementOrder', contractId: row.bizId, contractClass: row.bizClass });
      }
    },
    // 编辑试用转租赁
    editTryContinueContract(row) {
      this.clearTagByKeep('leaseaManagement_item_rent');
      this.jump('/contract/agreementOrder/leaseaorderedit', {
        lastOrderId: row.lastOrderId,
        contractId: row.bizId,
        contractClass: row.bizClass,
        orderType: '30',
        parentPath: '/contract/agreementOrder'
      });
    },
    copyAgreementOrder(row) {
      this.clearTagByKeep('inventoryManagement_item');
      this.jump('/redirect/contract/agreementOrder/copy', { parentPath: '/contract/agreementOrder', contractId: row.bizId, contractClass: row.bizClass, copy: true });
    },
    // 更多操作
    showMore: function (row) {
      this.$set(row, 'showMoreAction', true);
      return '';
    },
    getContract: function () {
      this.isLoading = true;
      this.formSearch.signingStartDate = this.formSearch.signingTime && this.formSearch.signingTime[0] ? this.formSearch.signingTime[0] : undefined;
      this.formSearch.signingEndDate = this.formSearch.signingTime && this.formSearch.signingTime[1] ? this.formSearch.signingTime[1] : undefined;
      this.formSearch.submitStartDate = this.formSearch.submitTime && this.formSearch.submitTime[0] ? this.formSearch.submitTime[0] : undefined;
      this.formSearch.submitEndDate = this.formSearch.submitTime && this.formSearch.submitTime[1] ? this.formSearch.submitTime[1] : undefined;
      this.formSearch.effectiveStartDate = this.formSearch.effectiveDate && this.formSearch.effectiveDate[0] ? this.formSearch.effectiveDate[0] : undefined;
      this.formSearch.effectiveEndDate = this.formSearch.effectiveDate && this.formSearch.effectiveDate[1] ? this.formSearch.effectiveDate[1] : undefined;
      this.formSearch.loadRes = this.$route.path;
      this.$getJSON(apis.crmContractOrderPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.totalRows = res.data.total;

        const data = res.data.list || [];
        data.forEach((item) => {
          this.contractControl(item);
        });
        this.contractList = data;
      });
    },
    // 合同变更控制
    contractControl: function (detail) {
      // (1)合同类型： 10-试用合同，20-租赁合同，21-续租合同，30-框架合同，41-E类购，42-新机购，43-租转售，40-租售订单
      // (2)合同业务状态: 1-草稿，6-审批中，10-审批通过，20-已生效，21-总部已发货，22-售后公司已收货，23-售后公司已发货，24-租赁方已收货，26-租赁方已发货，
      // 31-部分试用，32-已试用，35-部分启租，36-已启租，66-部分违约，70-已终止，80-已到期，90-审批拒绝，100-已作废
      // (3)合同角色: 甲方(JV)partyAId、售后公司(SC)afterServiceId、乙方(CS)customerId、总部(HQ)(独立于合同角色外，为创建合同账号的总部)
      // (4)合同变更: 变更设备 device、终止合同 stop_contract、变更启租日期 rent_date、变更售后公司 after_service
      // 暂停使用 stop_use、终止设备租赁 stop_rent、期末续机 continue_rent、变更支付周期 payment_cycle
      // (5)操作类型（'起租'在详情设备tab里，'审批,作废'合同列表和合同详情都要，其前面都在合同列表里，其后面都在合同详情里）: 终止试用 stop_test、试用转租赁 test_to_rent、编辑 edit、删除 delete、提交 submit、打印合同 print、查看 watch、启租（设备里面） start、撤销 cancel
      // 打印确认单 printConfirm、修改负责人 changeHead、审批 verify、作废 revoke、总部发货 factorySend、售后发货 aftersaleSend、乙方收货 partybReceive，firstPay 修改首付款
      const contractRoles = this.getCurContractRole(detail);
      // this.getDictionary('crm_order_handle_control', (dic) => {
      //   const contractHandle = this.contractAuthControl(dic.crm_order_handle_control, detail.contractType, detail.orderBizState, contractRoles);
      //   this.$set(detail, 'contractHandle', contractHandle);
      // });
      const contractHandle = this.contractAuthControl(contractRule.handleRules, detail.orderType, detail.orderBizState, contractRoles);
      this.$set(detail, 'contractHandle', contractHandle);
    },
    // 合同控制（操作/变更）
    contractAuthControl: function (rules, contractType, contractState, contractRoles) {
      const stateList = this.listFindOneChildren(rules, contractType);
      const actionList = this.listFindOneChildren(stateList, contractState);
      const result = actionList.filter(t => contractRoles.find(f => t.roleCode && t.roleCode.includes(f)));
      const data = {};
      result.forEach((item) => {
        data[item.value] = true;
      });
      return data;
    },
    // 获取当前账号合同担任角色
    getCurContractRole: function (detail) {
      const userInfo = this.$store.state.userInfo;
      const rootOrgId = userInfo ? userInfo.rootOrgId : ''; // 当前账户组织
      const contractRoles = []; // 当前用户在合同中担任角色列表
      // 是否是总部
      if (userInfo && userInfo.bizType === 'HQ') {
        contractRoles.push('HQ');
      }
      if (`${rootOrgId}` === `${detail.partyAId}`) {
        contractRoles.push('JV');
      }
      if (`${rootOrgId}` === `${detail.afterServiceId}`) {
        contractRoles.push('SC');
      }
      if (`${rootOrgId}` === `${detail.customerId}`) {
        contractRoles.push('CS');
      }
      return contractRoles;
    },

    // 字典处理函数
    listFindOneChildren: function (list, value) {
      let result = [];
      const row = list.find(t => `${t.value}` === `${value}`);
      if (row) {
        result = row.children || [];
      }
      return result;
    },
    // 合同操作
    onContractHandle: function ({ showType, row }) {
      // 期末续租
      if (showType === 'date_end_continue') {
        this.jump('/contract/agreementOrder/leasecontinueadd', {
          lastOrderId: row.bizId,
          oldContractId: this.contractId,
          oldContractClass: this.contractClass,
        });
        return;
      }
      // 试用转租赁
      if (showType === 'test_to_rent') {
        this.jump('/contract/agreementOrder/leaserentadd', {
          lastOrderId: row.bizId,
          oldContractId: this.contractId,
          oldContractClass: this.contractClass,
        });
        return;
      }
      if (showType === 'approval') {
        this.dialogModel6.title = this.$t('crm_manage.shen_pi_he_tong');
      }
      if (showType === 'factorySend') {
        this.dialogModel6.title = this.$t('crm_manage.zong_bu_fa_huo');
      }
      if (showType === 'aftersaleSend') {
        this.dialogModel6.title = this.$t('crm_manage.shgsfh');
      }
      if (showType === 'partybReceive') {
        this.dialogModel6.title = this.$t('crm_manage.zu_lin_fang_shou_huo');
      }
      if (showType === 'firstpay') {
        this.dialogModel6.title = this.$t('crm_manage.bgsfk');
      }
      this.dialogModel6.data = row;
      this.dialogVisible6 = showType;
    },
    // 操作按钮要传row
    beforeHandleCommand(item, row) {
      return {
        showType: item,
        row: row,
      };
    },
    // 合同操作弹窗
    onSetDialog: function (type, row) {
      this.dialogSetData = row;
      this.visibleSet = type;
    },
    // 合同类型
    contractTypeChange: function (num) {
      this.formSearch.contractType = num;
      this.onPageChange({ page: 1 });
    },
    deleteContract: function (row) {
      this.$showConfirm(this.$t('crm_manage.nqdyscdqhtm'))
        .then(() => {
          this.$postJSON(apis.contractDelete, {
            bizClass: row.bizClass,
            bizId: row.bizId,
          }).then(() => {
            this.$message({
              message: this.$t('crm_manage.schtcg'),
              type: 'success',
            });
            this.getContract();
          });
        })
        .catch(() => { });
    },
    submitContract: function (row) {
      this.$showConfirm(this.$t('crm_manage.nqdytjhtm'))
        .then(() => {
          this.$postJSON(apis.contractSubmit, {
            bizClass: row.bizClass,
            bizId: row.bizId,
          }).then(() => {
            this.$message({
              message: this.$t('crm_manage.tjhtcg'),
              type: 'success',
            });
            this.getContract();
          });
        })
        .catch(() => { });
    },
    // 撤销
    cancelContract: function (type, id) {
      this.$showConfirm(this.$t('crm_manage.nqdycxdqhtm'))
        .then(() => {
          this.$postJSON(`${apis.apsApproveApprovalApproveRevoke}/${type}/${id}`).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getContract();
            }
          });
        })
        .catch(() => { });
    },
    // 撤销
    revokeContract: function (type, id) {
      this.$showConfirm(this.$t('crm_manage.nqdyzfdqhtm'))
        .then(() => {
          this.$postJSON(`${apis.apsApproveApprovalCancel}/${type}/${id}`).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getContract();
            }
          });
        })
        .catch(() => { });
    },
    // 修改业务负责人
    onEditSalesman(row) {
      this.dialogVisible7 = true;
      this.dialogModel7.title = this.$t('crm_manage.bjywfzr');
      this.dialogModel7.bizId = row.bizId;
      this.dialogModel7.bizClass = row.bizClass;
      this.dialogModel7.partyAId = row.partyAId;
    },
    modifyLeaderContract: function ({ bizClass, bizId, projectContactName, projectContactPhone }) {
      this.dialogVisible1 = true;
      this.dialogModel1.title = this.$t('crm_manage.xgxmfzr');
      // 项目负责人
      this.dialogModel1.data = {
        bizClass,
        bizId,
        projectContactName,
        projectContactPhone,
      };
    },
    returnContract: function (contractId) {
      this.dialogVisible2 = true;
      this.dialogModel2.title = this.$t('crm_manage.tui_hui_he_tong');
      this.dialogData2.contractId = contractId;
    },

    // 下载租赁确认单
    downloadConfirmed(row) {
      this.dialogVisible5 = true;
      this.dialogModel5.title = this.$t('crm_manage.xuan_ze_she_bei');
      this.dialogModel5.bizId = row.bizId;
      this.dialogModel5.bizClass = row.bizClass;
      this.dialogModel5.type = 'order';
    },
    // 更多筛选显示
    searchFiltersShow: function () {
      this.searchFilters = !this.searchFilters;
    },
    onContractType(val) {
      this.$emit('input', val);
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getContract();
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getContract();
    },

    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.crmContractOrderExport, this.formSearch).then(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.management-bd {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-left: 16px;
}
</style>
